import { Store } from '../core/createStore';
import User from '../entity/user';
import UserRepository from '../service/userRepository';

import {
  dispose,
  setUser,
} from '../state/editUser';

class EditUser {
  private userRepository: UserRepository;
  private store: Store;

  constructor({
    userRepository,
    store,
  }: {
    userRepository: UserRepository;
    store: Store;
  }) {
    this.userRepository = userRepository;
    this.store = store;
  }

  public async initialize(): Promise<void> {
    const session = this.store.getState().currentSession;

    if (!session) {
      throw new Error('It is cannot have reach here.');
    }

    const user = await this.userRepository.getUserBySession(session);
    this.store.dispatch(setUser(user));
  }

  public updateUserField(partial: Partial<User>): void {
    const current = this.store.getState().editUser.user;
    const user = new User({ ...current, ...partial } as User);

    this.store.dispatch(setUser(user));
  }

  public async save(): Promise<User> {
    const session = this.store.getState().currentSession;
    const { user } = this.store.getState().editUser;

    if (!session || !user) {
      throw new Error('It is cannot have reach here.');
    }

    try {
      return await this.userRepository.saveUser(
        session,
        { user },
      );
    } catch (err) {
      throw err;
    }
  }

  public dispose(): void {
    this.store.dispatch(dispose());
  }
}

export default EditUser;
